import React from 'react';
import moment from 'moment';
import { Alert } from 'react-bootstrap';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import Constants from '../../config/constants';
import DataTable from '../datatable/DataTable';
import renderDeleteConfirmation from './DeleteConfirmation';

import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';
import { defaultRejectHandler, stringifyErrorMessage } from '../../utils/utility';
import { listProjectInvitation, revokeProjectInvitation } from '../../redux/project_inv/project_inv_actions';


class PendingProjectInvitationTable extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    this.state = {
      isShowInvRevokeConfirm: false,
      selectedInvitation: null,
      revokeErrorMessage: null,
    };

    const { t } = props;
    this.columns = [
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'invitee_name',
        ...getColumnStyle(COLUMN_STYLE.text),
      },
      {
        Header: () => <b>{t('date')}</b>,
        accessor: 'created_date',
        Cell: row => moment(row.value).format('DD-MM-YYYY hh:mm'),
        ...getColumnStyle(COLUMN_STYLE.text),
        width: 160,
      },
    ];
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isRevoking && (this.props.isRevoking !== nextProps.isRevoking)) {
      if (!nextProps.errorMessage) {
        this.setState({ isShowInvRevokeConfirm: false });
      } else {
        this.setState({ isShowInvRevokeConfirm: true, revokeErrorMessage: nextProps.errorMessage });
      }
    }
  }

  updateSortFilter(search, state) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.search = search;

    this.props.listInvitation(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.search,
      this.props.owner.id,
    );
  }

  renderErrorMessage(errorMessage) {
    if (!errorMessage) return null;
    return (
      <Alert
        bsStyle="danger"
        style={{ 'white-space': 'pre' }}
        onDismiss={() => this.setState({ revokeErrorMessage: null })}
      >
        {errorMessage}
      </Alert>
    );
  }

  render() {
    const {
      invitations,
      filteredCount,
      isLoading,
      revokeInvitation,
      isRevoking,
      t,
    } = this.props;

    const {
      isShowInvRevokeConfirm,
      selectedInvitation: invitation,
      revokeErrorMessage,
    } = this.state;
    return (
      <div>
        {isShowInvRevokeConfirm &&
          renderDeleteConfirmation(
            invitation.invitee_name,
            isRevoking,
            () => revokeInvitation(invitation.id),
            () => this.setState({ isShowInvRevokeConfirm: false }),
            t,
          )}
        {revokeErrorMessage && this.renderErrorMessage(stringifyErrorMessage(revokeErrorMessage))}
        <DataTable
          columns={this.columns}
          data={invitations}
          onActionDelete={item => this.setState({ isShowInvRevokeConfirm: true, selectedInvitation: item.original })}
          filteredCount={filteredCount}
          isLoading={isLoading}
          onFetchData={state => this.updateSortFilter(this.search.search, state)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  invitations: state.projectInvitation.orderedIds.map(id => state.projectInvitation.objects[id]),
  isLoading: state.projectInvitation.isLoading,
  totalCount: state.projectInvitation.totalCount,
  filteredCount: state.projectInvitation.filteredCount,
  errorMessage: state.projectInvitation.errorMessage,
  isRevoking: state.projectInvitation.isRevoking,
});

const mapDispatchToProps = (dispatch) => ({
  listInvitation: (pageSize, page, sorted, filtered, inviter_id) =>
    defaultRejectHandler(dispatch(listProjectInvitation(pageSize, page, sorted, filtered, null, inviter_id, 'pending'))),
  revokeInvitation: (id) => defaultRejectHandler(dispatch(revokeProjectInvitation(id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(PendingProjectInvitationTable),
);



// WEBPACK FOOTER //
// ./src/components/member/PendingProjectInvitationTable.js